/** 静态变量 **/
import { OID_MAP } from "@/utils/constants/constants.track";
import { QLM_MBA_URL, PRODUCT_MANUAL } from "@/utils/constants/constants.menu";

export const CDN = process.env.VUE_APP_OSS_CDN;
export const OFFICIAL_WEBSITE_HOME = process.env["VUE_APP_OFFICIAL_WEBSITE_HOME"];
export const TITLE = "千里马招标网";
export const OFFICIAL_WEBSITE = "//www.qianlima.com";
export const LOCAL_STORAGE_KEY_MAP = {
  SEARCH_HISTORY: "SEARCH_HISTORY", // 搜索栏 搜索历史
  OLD_SEARCH_HISTORY: "historyItemsNew", // 老大搜 搜索历史 todo 新大搜上线后删除
};

export const HEADER_TYPE = {
  DEFAULT: "default",
  SEARCH: "search",
  CUSTOM: "custom", // 自定义header
};

export const HEADER_CUSTOM_ID = {
  DEFAULT: "default",
  LOGIN: "login",
  PRODUCT_MANUAL: "productManual",
};

export const HEADER_CUSTOM = [
  {
    id: HEADER_CUSTOM_ID.DEFAULT,
    value: {},
  },
  {
    id: HEADER_CUSTOM_ID.LOGIN,
    value: { btnStyle: { background: "#d7000f" } },
  },
  {
    id: HEADER_CUSTOM_ID.PRODUCT_MANUAL,
    value: {
      logoImg: require("@/assets/img/LayoutHeader/logo-product-manual.png"),
      imgStyle: { width: "188px" },
      showRight: false,
      showLogoRightText: false,
    },
  },
];
export const DEFAULT_RELATED_SEARCH = ["电梯", "雕塑", "泵", "景观", "阀门", "污水", "喷泉", "机场"];
export const DEFAULT_RELATED_SEARCH_TIPS = "注：支持多关键词搜索，加号(+)表示且的关系，空格表示或的关系";

export const OLD_USER_CENTER_URL = process.env.VUE_APP_OLD_USER_CENTER_URL;
export const USER_DETAIL_URL = process.env.VUE_APP_OLD_DETAIL_URL;
export const OLD_SEARCH_URL = process.env.VUE_APP_OLD_SEARCH_URL;

/** 帮助中心 新手引导 **/
export const LOGIN_URL = OLD_USER_CENTER_URL + "/login.html";
export const REGISTER_URL = OLD_USER_CENTER_URL + "/register.html";
export const SUBSCRIBE_SETTING_TENDER_URL = OLD_USER_CENTER_URL + "/subscriptionCenter_Setting_Tender.html?from_type=1";
export const USER_APPLICATION_MONITOR_URL = "/enterprise-monitoring/monitoring-list";

/** 企业商情分析 **/
export const COMPANY_ANALYSE_URL = USER_DETAIL_URL + "/companyAnalyse.html";
export const BUSINESS_ANALYSE_URL = OLD_USER_CENTER_URL + "/userApplication_BusinessAnalysis.html";
//公司详情页面
export const COMPANY_SUPPLIERDETAIL = USER_DETAIL_URL + "/supplierDetail.html";
//企业套餐
export const ENTERPRISE_PACKAGE = OFFICIAL_WEBSITE_HOME + "/enterprise-package";
//产品服务
export const PRODUCTS_SERVICES = OFFICIAL_WEBSITE_HOME + "/product-services";
//选择套餐页面
export const CHOOSE_PACKAGE = OFFICIAL_WEBSITE_HOME + "/choose-package";
export const ABOUT_US = "http://qianlima.group/"; //关于千里马
export const VIDEO_TUTORIAL = [
  {
    url: "https://appwzww0tbr3618.h5.xiaoeknow.com/v1/course/video/v_606fcc18e4b09890f0e1d41f?type=2",
    img: `${CDN}/0cdn/common/file/helpCenter/images/img1.jpg`,
  },
  {
    url: "https://appwzww0tbr3618.h5.xiaoeknow.com/v1/course/video/v_606d93fbe4b071a81eafc343?type=2",
    img: `${CDN}/0cdn/common/file/helpCenter/images/img2.jpg`,
  },
  {
    url: "https://appwzww0tbr3618.h5.xiaoeknow.com/v1/course/video/v_60868441e4b071a81eb5a30b?type=2",
    img: `${CDN}/0cdn/common/file/helpCenter/images/img3.jpg`,
  },
  {
    url: QLM_MBA_URL,
  },
];

export const OPERATION_MANUAL = [
  {
    url: PRODUCT_MANUAL + "?id=1",
    text: "快速上手",
  },
  {
    url: PRODUCT_MANUAL + "?id=2",
    text: "账号登录",
  },
  {
    url: PRODUCT_MANUAL + "?id=3",
    text: "使用千里马微信公众号",
  },
  {
    url: PRODUCT_MANUAL + "?id=4",
    text: "新手入驻",
  },
];

export const FOOTER = {
  ENTRANCES: [
    {
      text: "千里马首页",
      url: OFFICIAL_WEBSITE,
    },
    {
      text: "关于我们",
      url: OFFICIAL_WEBSITE + "/about/about.shtml",
    },
    {
      text: "联系我们",
      url: OFFICIAL_WEBSITE + "/about/contact.shtml",
    },
    {
      text: "成功案例",
      url: OFFICIAL_WEBSITE + "/common/cgal.jsp",
    },
    {
      text: "会员服务",
      url: OFFICIAL_WEBSITE + "/about/huiyuan.shtml",
    },
    {
      text: "付款方式",
      url: OFFICIAL_WEBSITE + "/about/fkfs.shtml",
    },
    {
      text: "招标法规",
      url: OFFICIAL_WEBSITE + "/common/law_list.jsp",
    },
    {
      text: "网站声明",
      url: OFFICIAL_WEBSITE + "/about/copyright.shtml",
    },
    {
      text: "友情链接",
      url: OFFICIAL_WEBSITE + "/about/yqlj.shtml",
    },
    {
      text: "网站地图",
      url: OFFICIAL_WEBSITE + "/common/sitemap.html",
    },
    {
      text: "收藏本站",
      url: "#",
    },
  ],
  ICP_RECORD: {
    text: "京ICP证160587号 京ICP备16007318号",
    url: "http://beian.miit.gov.cn/",
  },
  PUBLIC_RECORD: {
    img: `${CDN}/0cdn/static/front/img/beian.png`,
    text: "京公网安备 11010802022728号",
    url: "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802022728",
  },
  REPORT: {
    img: `${CDN}/0cdn/static/front/img/bot_1.gif`,
    url: "http://net.china.cn/",
  },
  POLICE: {
    img: `${CDN}/0cdn/static/front/img/bot_2.gif`,
    url: "http://www.bj.cyberpolice.cn/index.do",
  },
};

export const CLASSIFY_A = [
  {
    text: "全文",
    isNew: true,
    id: 8,
  },
  {
    text: "全文和附件",
    isNew: false,
    id: 1,
  },
  {
    text: "标题",
    isNew: false,
    id: 2,
  },
  {
    text: "标的物",
    isNew: true,
    id: 9,
  },
  {
    text: "项目编号",
    isNew: false,
    id: 3,
  },
  {
    text: "招标单位",
    isNew: false,
    id: 4,
  },
  {
    text: "中标单位",
    isNew: false,
    id: 5,
  },
  {
    text: "代理单位",
    isNew: false,
    id: 6,
  },
  {
    text: "联系人",
    isNew: false,
    id: 7,
  },
];
export const CLASSIFY_B = [
  {
    text: "全文",
    isNew: true,
    id: 8,
  },
  {
    text: "全文和附件",
    isNew: false,
    id: 1,
  },
  {
    text: "标题",
    isNew: false,
    id: 2,
  },
];

/** 更多公司 **/
export const MORE_COMPANY_URL = process.env.VUE_APP_OLD_SEARCH_URL + "/moreCompany.html";

export const TYPE_ALL = [
  {
    id: -1,
    text: "全部",
    point: OID_MAP.SEARCH_TYPEALL_CLICK,
    extendinfo: "全部",
  },
  {
    id: 0,
    text: "招标信息",
    point: OID_MAP.SEARCH_TYPEALL_CLICK,
    extendinfo: "招标信息",
  },
  {
    id: 3,
    text: "中标信息",
    point: OID_MAP.SEARCH_TYPEALL_CLICK,
    extendinfo: "中标信息",
  },
  {
    id: 99,
    text: "采购意向",
    point: OID_MAP.SEARCH_TYPEALL_CLICK,
    extendinfo: "采购意向",
  },
];
export const MODE_LIST = [
  {
    id: 1,
    text: "精准",
  },
  {
    id: 0,
    text: "模糊",
  },
];

export const TIME_LIST = [
  {
    id: 7,
    text: "今天",
  },
  {
    id: 2,
    text: "近7天",
  },
  {
    id: 3,
    text: "近30天",
  },
  {
    id: 8,
    text: "近90天",
  },
  {
    id: 9,
    text: "近半年",
  },
  {
    id: 1,
    text: "近一年",
  },
  {
    id: 40,
    text: "往年",
  },
  {
    id: 4,
    text: "自定义",
  },
];

export const BIDDING_TYPE = [
  {
    id: 0,
    text: "公开招标",
    point: OID_MAP.SEARCH_VIPBIDDINGTYPE_OPEN_CLICK,
  },
  {
    id: 1,
    text: "邀请招标",
    point: OID_MAP.SEARCH_VIPBIDDINGTYPE_INCITE_CLICK,
  },
  {
    id: 2,
    text: "竞争性谈判/磋商",
    point: OID_MAP.SEARCH_VIPBIDDINGTYPE_COMPET_CLICK,
  },
  {
    id: 3,
    text: "单一来源",
    point: OID_MAP.SEARCH_VIPBIDDINGTYPE_SINGLE_CLICK,
  },
  {
    id: 6,
    text: "电子卖场",
    point: OID_MAP.SEARCH_VIPBIDDINGTYPE_ELECTRON_CLICK,
  },
];

export const FUND_SOURCE = [
  {
    id: 1,
    text: "财政资金",
    point: OID_MAP.SEARCH_VVIPFUNDSOURCE_FINANCE_CLICK,
  },
  {
    id: 2,
    text: "专项资金及债券",
    point: OID_MAP.SEARCH_VIPFUNDSOURCE_SPECIAL_CLICK,
  },
  {
    id: 3,
    text: "银行贷款",
    point: OID_MAP.SEARCH_VIPFUNDSOURCE_BANK_CLICK,
  },
  {
    id: 4,
    text: "投资/融资",
    point: OID_MAP.SEARCH_VIPFUNDSOURCE_INVEST_CLICK,
  },
  {
    id: 5,
    text: "单位自筹",
    point: OID_MAP.SEARCH_VIPFUNDSOURCE_RAISE_CLICK,
  },
];

export const HAS_AGENT = [
  {
    id: 1,
    text: "有代理机构",
    point: OID_MAP.SEARCH_VIPAGENT_CLICK,
  },
  {
    id: 0,
    text: "无代理机构",
    point: OID_MAP.SEARCH_VIPAGENT_CLICK,
  },
];

export const REGISTRATION = [
  {
    id: 1,
    text: "未结束",
    point: OID_MAP.SEARCH_VIPREGISTRATION_NOTOVER_CLICK,
  },
  {
    id: 2,
    text: "已结束",
    point: OID_MAP.SEARCH_VIPREGISTRATION_OVER_CLICK,
  },
  {
    id: -2,
    text: "无时间",
  },
];

export const AMOUNT = [
  {
    id: -1,
    beginAmount: "",
    endAmount: "",
    text: "不限",
  },
  {
    id: 2,
    beginAmount: 0,
    endAmount: 100000,
    text: "10万以下",
    point: OID_MAP.SEARCH_VIPAMOUNT_TEN_CLICK,
  },
  {
    id: 3,
    beginAmount: 100000,
    endAmount: 500000,
    text: "10万-50万",
    point: OID_MAP.SEARCH_VIPAMOUNT_FIFTY_CLICK,
  },
  {
    id: 4,
    beginAmount: 500000,
    endAmount: 1000000,
    text: "50万-100万",
    point: OID_MAP.SEARCH_VIPAMOUNT_HUNDRED_CLICK,
  },
  {
    id: 5,
    beginAmount: 1000000,
    endAmount: 2000000,
    text: "100万-200万",
    point: OID_MAP.SEARCH_VIPAMOUNT_TOWHUNDRED_CLICK,
  },
  {
    id: 6,
    beginAmount: 2000000,
    endAmount: "",
    text: "200万以上",
    point: OID_MAP.SEARCH_VIPAMOUNT_FIVEHUNDRED_CLICK,
  },
  {
    id: 99,
    beginAmount: "",
    endAmount: "",
    text: "",
    hide: true,
  },
];

export const HAS_PHONE = [
  {
    id: 3,
    text: "有招标联系电话",
    point: OID_MAP.SEARCH_VIPHASPHONE_BIDDING_CLICK,
  },
  {
    id: 4,
    text: "有中标联系电话",
    point: OID_MAP.SEARCH_VIPHASPHONE_WINBIDDING_CLICK,
  },
];
export const HAS_PHONE_A = [
  {
    id: 3,
    text: "有招标联系电话",
    point: OID_MAP.SEARCH_VIPHASPHONE_BIDDING_CLICK,
  },
];
export const HAS_LINK_NAME = [
  {
    id: 1,
    text: "有招标联系人",
    point: OID_MAP.SEARCH_VIPHASLINKNAME_BIDDING_CLICK,
  },
  {
    id: 2,
    text: "有中标联系人",
    point: OID_MAP.SEARCH_VIPHASLINKNAME_WINBIDDING_CLICK,
  },
];
export const HAS_LINK_NAME_A = [
  {
    id: 1,
    text: "有招标联系人",
    point: OID_MAP.SEARCH_VIPHASLINKNAME_BIDDING_CLICK,
  },
];

export const WINBIDDING_TYPE = [
  {
    text: "中标通知",
    pid: 3,
    id: 1011,
  },
  {
    text: "合同公告",
    pid: 3,
    id: 1012,
  },
  {
    text: "候选人公示",
    pid: 3,
    id: 1010,
  },
  {
    text: "开标公示",
    pid: 3,
    id: 1009,
  },
  {
    text: "流标公告",
    pid: 3,
    id: 1008,
  },
  {
    text: "废标公告",
    pid: 3,
    id: 1007,
  },
  {
    text: "国土",
    pid: 4,
    id: 999,
  },
  {
    text: "其他",
    pid: 5,
    id: 1013,
  },
];

export const PROJECT_TYPE = [
  {
    id: -1,
    text: "全部",
  },
  {
    id: 1102,
    text: "可研",
  },
  {
    id: 1106,
    text: "立项",
  },
  {
    id: 1105,
    text: "核准",
  },
  {
    id: 1103,
    text: "备案",
  },
  {
    id: 1101,
    text: "环评",
  },
  {
    id: 1104,
    text: "审批",
  },
  {
    id: 1201,
    text: "设计阶段",
  },
  {
    id: 1300,
    text: "施工准备",
  },
  {
    id: 1400,
    text: "施工在建",
  },
  {
    id: 1500,
    text: "竣工",
  },
];
export const APPROVAL_TYPE = [
  {
    id: -1,
    text: "全部",
  },
  {
    id: 36,
    text: "立项",
  },
  {
    id: 32,
    text: "可研",
  },
  {
    id: 33,
    text: "审批",
  },
  {
    id: 34,
    text: "备案",
  },
  {
    id: 35,
    text: "核准",
  },
  {
    id: 31,
    text: "环评",
  },
  {
    id: 61,
    text: "施工许可",
  },
  {
    id: 37,
    text: "竣工",
  },
];

export const SORT_TYPE = [
  {
    label: 2,
    name: "综合排序",
    point: OID_MAP.SEARCH_SORT_CLICK,
  },
  {
    label: 1,
    name: "按时间排序",
    point: OID_MAP.SEARCH_SORT_CLICK,
  },
  {
    label: 6,
    name: "相关性排序",
    point: OID_MAP.SEARCH_SORTRELEATE_CLICK,
  },
];
export const BRIEFDETAIL_TYPE = [
  {
    label: 0,
    name: "简要",
    active: false,
    point: OID_MAP.SEARCH_BRIEF_CLICK,
  },
  {
    label: 1,
    name: "明细",
    active: false,
    point: OID_MAP.SEARCH_DETAIL_CLICK,
  },
];

export const MEDICAL_CLOUD_URL = "http://mdc.qianlima.com"; //医疗云地址

export const BEIJING_ICP_CERTIFICATE_URL = "https://beian.miit.gov.cn/"; // 京ICP证160587号
export const BEIJING_PUBLIC_NETWORK = "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802022728"; //京公网安备 11010802022728号
